import { useEffect, useState, useRef, useCallback } from 'react';

export function usePrevious(value, defaultValue) {
	const ref = useRef();

	useEffect(() => {
		ref.current = value;
	}, [value]);

	return typeof ref.current === 'undefined' ? defaultValue : ref.current;
}

export function useMounted() {
	const isMounted = useRef(false);

	useEffect(() => {
		isMounted.current = true;

		return () => {
			isMounted.current = false;
		};
	}, []);

	return useCallback(() => isMounted.current, []);
}

export function useDebounce(cb, delay) {
	const [debounceValue, setDebounceValue] = useState(cb);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebounceValue(cb);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [cb, delay]);

	return debounceValue;
}

export function useDidUpdate(fn, inputs) {
	const isMountingRef = useRef(false);

	useEffect(() => {
		isMountingRef.current = true;
	}, []);

	useEffect(() => {
		if (!isMountingRef.current) {
			return fn();
		} else {
			isMountingRef.current = false;
		}
	}, inputs);
}
